/**
 * useDocument hook
 * 提供访问文档上下文的便捷方式
 *
 * 核心功能：
 * 1. 访问DocumentContext
 * 2. 提供类型安全的上下文访问
 * 3. 确保在Provider内部使用
 */
import { useContext } from 'react';
import { DocumentContext } from '../contexts/DocumentContext.js';
/**
 * 文档上下文Hook
 * 便于在组件中使用文档上下文
 *
 * @returns 文档上下文值，包含状态和操作方法
 * @throws 如果在DocumentProvider外部使用则抛出错误
 */
export const useDocument = () => {
    const context = useContext(DocumentContext);
    if (context === undefined) {
        throw new Error('useDocument must be used within a DocumentProvider');
    }
    return context;
};
//# sourceMappingURL=useDocument.js.map